import { NoteTypeData, TaskShotBidDataForNotes } from "@/graphql/fragments";
import gql from "graphql-tag";

export const FEEDBACK_NOTE_QUERY = gql`
  query FeedbackNote($taskShotIds: [SmartID]) {
    feedbackNote(taskShotIds: $taskShotIds) {
      id
      note
      sharedInformation {
        userName
        message
        createdAt
        attachments {
          id
          key
          name
          url
        }
      }
      noteType {
        id
        ...NoteType
      }
      taskShotBidDelivery {
        id
        taskShotBid {
          id
          ...TaskShotBidDataForNotes
        }
        vendorDelivery {
          id
          notes
          deliveryKeysToTaskShotIds {
            key
            taskShotId
          }
          deliveryUrlToTaskShotIds {
            taskShotId
            url
          }
          deliveryPreviewLink {
            taskShotId
            url
          }
        }
        versionNumber
      }
      attachments {
        id
        url
        key
        name
      }
      createdBy {
        id
        fullName
      }
      created
    }
  }
  ${NoteTypeData}
  ${TaskShotBidDataForNotes}
`;
